import React from 'react';
import { observer } from 'mobx-react';
import i_ from 'i18next';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';

class TextFieldCustom extends React.Component {
  static propTypes = {
    type: PropTypes.string,
    item: PropTypes.object.isRequired,
    entity: PropTypes.string,
    field: PropTypes.string.isRequired,
    valueType: PropTypes.string,
    fullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    errorText: PropTypes.string,
    label: PropTypes.string,
    rows: PropTypes.number,
    rowsMax: PropTypes.number,
    onBlur: PropTypes.func,
  };

  static defaultProps = {
    type: 'text',
    valueType: 'text',
    fullWidth: false,
    disabled: false,
    errorText: '',
    floatingLabelText: '',
    rows: 1,
  };

  text = e => (this.props.item[this.props.field] = e.target.value);

  document = e =>
    (this.props.item[this.props.field] = e.target.value.formatDocument());

  render() {
    const {
      valueType,
      type,
      item,
      field,
      fullWidth,
      disabled,
      label,
      rows,
      rowsMax,
      entity,
      onBlur,
    } = this.props;
    let value = item[field];
    if (type === 'date') {
      value = moment(value).format('YYYY-MM-DD');
    }
    return (
      <TextField
        type={type}
        value={value}
        onChange={this[valueType]}
        fullWidth={fullWidth}
        disabled={disabled}
        label={
          entity
            ? i_.t(`${entity.camelToDash()}.${field.camelToDash()}`)
            : label
        }
        rows={rows}
        rowsMax={rowsMax}
        onBlur={e => {
          if (onBlur) onBlur(e);
        }}
      />
    );
  }
}

export default observer(TextFieldCustom);



// WEBPACK FOOTER //
// ./src/components/commons/TextField.js